import React from 'react';

export const RightPageIcon = () => (
    <svg width="4" height="8" viewBox="0 0 4 8" fill="inherit" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.117157 0.130175C-0.039053 0.303741 -0.039053 0.585148 0.117157 0.758714L3.03431 4L0.117157 7.24129C-0.039053 7.41485 -0.039053 7.69626 0.117157 7.86983C0.273367 8.04339 0.526633 8.04339 0.682842 7.86983L3.88284 4.31427C4.03905 4.1407 4.03905 3.8593 3.88284 3.68573L0.682842 0.130175C0.526633 -0.0433916 0.273367 -0.0433916 0.117157 0.130175Z" fill="inherit"/>
    </svg>
);
